module.exports = {
apiUrl: 'https://participacionciudadana.valledelcauca.gov.co:3005'
     //apiUrl: 'http://localhost:3000'
   
}